var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 268,
    viewBox: "0 0 268 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 268,
    rx: 20,
    fill: "#FFCF29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7895 183.308C107.321 183.308 121.579 169.093 121.579 151.615V71.2352L193.105 97.1596V156.028C188.296 153.172 182.809 151.648 177.211 151.615C159.679 151.615 145.421 165.829 145.421 183.308C145.421 200.786 159.679 215 177.211 215C194.742 215 209 200.786 209 183.308V91.6134C209.001 89.9878 208.5 88.4014 207.564 87.0701C206.628 85.7388 205.304 84.7274 203.771 84.1736L116.35 52.4812C115.149 52.0438 113.861 51.9016 112.594 52.0668C111.327 52.232 110.119 52.6996 109.072 53.4299C108.025 54.1602 107.17 55.1317 106.581 56.2617C105.991 57.3918 105.683 58.6471 105.684 59.921V124.336C100.875 121.479 95.3875 119.956 89.7895 119.923C72.2576 119.923 58 134.137 58 151.615C58 169.093 72.2576 183.308 89.7895 183.308Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicLogo);
export default __webpack_public_path__ + "static/media/musicLogo.43b37e12b6aa1a2943534c38eb9094cc.svg";
export { ForwardRef as ReactComponent };